// src/components/Navbar.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { FaSearch } from "react-icons/fa";
import { FiMessageSquare, FiBell, FiLogOut, FiSettings, FiMenu } from "react-icons/fi";
import { FaChartLine, FaUserEdit } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import "./dash_Navbar.css";

export default function Navbar({ setSearchTerm }) {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState("");
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMobileMenu, setOpenMobileMenu] = useState("");
const toggleMobileMenu = (menu) => {
  setOpenMobileMenu(openMobileMenu === menu ? "" : menu);
};


  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };

  return (
    <>
      {/* TOP NAVBAR */}
      <div className="navbar">

        {/* MOBILE HAMBURGER */}
        <div className="mobile-hamburger" onClick={() => setDrawerOpen(true)}>
          <FiMenu size={26} />
        </div>

        {showMobileSearch ? (
            <input
              type="text"
              className="mobile-nav-search-input"
              placeholder="Search jobs, Locations..."
              autoFocus
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          ) : (
            <div className="logooo">StrideNext</div>
          )}



        <div className="nav-left desktop-only" >
        <div className="logoo">StrideNext</div>
          
        <div className="nav-item" onClick={() => toggleMenu("jobs")}> Jobs
         {openMenu === "jobs" && 
         ( <div className="dropdownr"> 
         <p onClick={()=>navigate("/recommended-jobs")}>Recommended Jobs</p>
          <p onClick={()=>navigate("/jobs")}>Prefered Jobs</p> 
          <p onClick={()=>navigate("/application-status")}>Application Status</p>
           <p onClick={()=>navigate("/interview-invite")}>Interview Invites</p> 
           <p onClick={()=>navigate("/savedjobs")}>Saved Jobs</p>
         </div> )} 
         </div> 
         
         <div className="nav-item" onClick={() => toggleMenu("services")}> Services 
         {openMenu === "services" && 
         ( <div className="dropdowns">
           <p>Interview preparation</p> 
           <p>Resume creation</p>
           </div> )} 
        </div> 
        </div>

        {/* DESKTOP SEARCH */}
        <div className="nav-search desktop-only">
          <input type="text" placeholder="Search jobs, Locations"
            onChange={(e) => setSearchTerm(e.target.value)} />
          <button className="search-btn"><FaSearch /></button>
        </div>

        {/* MOBILE SEARCH ICON */}
        <div className="mobile-search-icon" onClick={() => setShowMobileSearch(!showMobileSearch)}>
          <FaSearch size={20} />
        </div>

        <div className="nav-right desktop-only">
          <div className="nav-item" onClick={() => toggleMenu("messages")}>
            <FiMessageSquare />
            {openMenu === "messages" && (
              <div className="dropdownm"><p>No new messages</p></div>
            )}
          </div>

          <div className="nav-item" onClick={() => toggleMenu("notifications")}>
            <FiBell />
            {openMenu === "notifications" && (
              <div className="dropdownn"><p>No notifications</p></div>
            )}
          </div>

          <div className="nav-item" onClick={() => toggleMenu("profile")}>
            Profile
            {openMenu === "profile" && (
              <div className="dropdownp">
                <p><FaChartLine style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> Profile Performance</p>
                <p onClick={() => navigate("/candidate-profile")}><FaUserEdit style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> View & update profile</p>
                <p><FiSettings style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}} /> Settings</p>
                <p onClick={()=> navigate("/")}><FiLogOut style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> Logout</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* MOBILE SEARCH BAR */}
      {/* {showMobileSearch && (
        <div className="mobile-search-bar">
          <input
            type="text"
            placeholder="Search jobs, Locations..."
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )} */}

      {/* MOBILE DRAWER MENU */}
      {/* MOBILE DRAWER MENU */}
<div className={`mobile-drawer ${drawerOpen ? "open" : ""}`}>
  <div className="drawer-header">
    <span className="drawer-title">StrideNext</span>
    <span className="drawer-close" onClick={() => setDrawerOpen(false)}><MdClose/></span>
  </div>

  {/* JOBS */}
  <div className="drawer-section">
    <p className="drawer-item main-item" onClick={() => toggleMobileMenu("jobs")}>
      Jobs
    </p>
    {openMobileMenu === "jobs" && (
      <div className="submenu">
        <p className="drawer-sub" onClick={() => navigate("/recommended-jobs")}>Recommended Jobs</p>
        <p className="drawer-sub"onClick={()=>navigate("/jobs")} >Preferred Jobs</p>
        <p className="drawer-sub"onClick={()=>navigate("/application-status")}>Application Status</p>
        <p className="drawer-sub" onClick={()=>navigate("/interview-invite")}>Interview Invites</p>
        <p className="drawer-sub" onClick={()=>navigate("/savedjobs")}>Saved Jobs</p>
      </div>
    )}
  </div>

  {/* SERVICES */}
  <div className="drawer-section">
    <p className="drawer-item main-item" onClick={() => toggleMobileMenu("services")}>
      Services
    </p>
    {openMobileMenu === "services" && (
      <div className="submenu">
        <p className="drawer-sub">Interview Preparation</p>
        <p className="drawer-sub">Resume Creation</p>
      </div>
    )}
  </div>

  {/* MESSAGES */}
  <div className="drawer-section">
    <p className="drawer-item main-item" onClick={() => toggleMobileMenu("messages")}>
      Messages
    </p>
    {openMobileMenu === "messages" && (
      <div className="submenu">
        <p className="drawer-sub">No new messages</p>
      </div>
    )}
  </div>

  {/* NOTIFICATIONS */}
  <div className="drawer-section">
    <p className="drawer-item main-item" onClick={() => toggleMobileMenu("notifications")}>
      Notifications
    </p>
    {openMobileMenu === "notifications" && (
      <div className="submenu">
        <p className="drawer-sub">No notifications</p>
      </div>
    )}
  </div>

  {/* PROFILE */}
  <div className="drawer-section">
    <p className="drawer-item main-item" onClick={() => toggleMobileMenu("profile")}>
      Profile
    </p>
    {openMobileMenu === "profile" && (
      <div className="submenu">
        <p className="drawer-sub"> <FaChartLine style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> Profile Performance</p>
        <p className="drawer-sub" onClick={() => navigate("/candidate-profile")}><FaUserEdit style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> View & Update Profile</p>
        <p className="drawer-sub"><FiSettings style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}} />Settings</p>
        <p className="drawer-sub" onClick={()=>navigate("/")}><FiLogOut style={{color:"#4169e1", paddingRight:"4px", paddingTop:"3px"}}/> Logout</p>
      </div>
    )}
  </div>
</div>

    </>
  );
}
